(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/authorized-landing.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/authorized-landing.js');
"use strict";

const OverviewList = svs.ticket_gifts.redeem.components.OverviewList;
const SingleTicket = svs.ticket_gifts.redeem.components.SingleTicket;
const AuthorizedLanding = _ref => {
  var _vouchers$map;
  let {
    voucherData,
    history,
    match
  } = _ref;
  if (!voucherData || !voucherData.vouchers || voucherData.vouchers.error || voucherData.vouchers.length === 1 && voucherData.vouchers[0].state !== 'ACTIVE' || voucherData.vouchers.every(voucher => dateFns.parseISO(voucher.lastValidDate) < Date.now())) {
    window.location.href = "".concat(svs.core.data.baseUrl, "?err=").concat(match.params.giftCode);
    return null;
  }
  const {
    personalMessage,
    receiverName,
    vouchers,
    personalGreeting = null
  } = voucherData || {};
  const tickets = (_vouchers$map = vouchers === null || vouchers === void 0 ? void 0 : vouchers.map(voucher => {
    var _ref2, _ref3;
    const {
      state,
      voucherId,
      value,
      ticketPosition
    } = voucher;
    const ticketInfo = svs.ticket_gifts.chooseGameForVoucher(voucher);
    const backupTicketInfo = svs.ticket_gifts.games.find(game => game.voucherId === voucher.voucherConfigId);
    const skinId = (_ref2 = ticketInfo || backupTicketInfo) === null || _ref2 === void 0 ? void 0 : _ref2.normalizeSkinId(ticketPosition);
    return {
      ticketPrice: value,
      isRedeemed: state !== 'ACTIVE',
      giftCode: voucherId,
      img: (_ref3 = ticketInfo || backupTicketInfo) === null || _ref3 === void 0 || (_ref3 = _ref3.skins[skinId - 1]) === null || _ref3 === void 0 ? void 0 : _ref3.image,
      closed: Boolean(!ticketInfo),
      ticketName: (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name) || "".concat((backupTicketInfo === null || backupTicketInfo === void 0 ? void 0 : backupTicketInfo.name) || 'Lott', "(st\xE4ngd)"),
      availableOnline: Boolean(ticketInfo),
      voucherConfigId: voucher.voucherConfigId
    };
  })) !== null && _vouchers$map !== void 0 ? _vouchers$map : [];
  const isManyTickets = tickets.length > 1;
  return isManyTickets ? React.createElement(OverviewList, {
    history: history,
    message: personalMessage,
    personalGreeting: personalGreeting,
    toName: receiverName,
    vouchers: tickets
  }) : React.createElement(SingleTicket, {
    history: history,
    message: personalMessage,
    personalGreeting: personalGreeting,
    toName: receiverName,
    voucher: tickets[0]
  });
};
setGlobal('svs.ticket_gifts.redeem.components.AuthorizedLanding', AuthorizedLanding);

 })(window);